import { render, staticRenderFns } from "./CourseContents.vue?vue&type=template&id=835dd6a6&scoped=true&"
import script from "./CourseContents.vue?vue&type=script&lang=ts&"
export * from "./CourseContents.vue?vue&type=script&lang=ts&"
import style0 from "./CourseContents.vue?vue&type=style&index=0&id=835dd6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835dd6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('835dd6a6', component.options)
    } else {
      api.reload('835dd6a6', component.options)
    }
    module.hot.accept("./CourseContents.vue?vue&type=template&id=835dd6a6&scoped=true&", function () {
      api.rerender('835dd6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/CourseContents.vue"
export default component.exports